import React, { ReactNode } from 'react';

export interface ButtonCancelProps {
	children?: ReactNode;
	onClick: () => void;
}

export function ButtonCancel({ children, onClick }: ButtonCancelProps) {
	return (
		<button className='btn-text' onClick={onClick}>
			<svg
				className='inline-block relative -mt-0.5 h-4 w-4'
				fill='none'
				stroke='currentColor'
				strokeWidth='2'
				viewBox='0 0 24 24'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path d='M6 18L18 6M6 6l12 12' strokeLinecap='round' strokeLinejoin='round'></path>
			</svg>
			&nbsp;{children}
		</button>
	);
}
